import styled from "styled-components";

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  height: 100%;
  width: 100%;
  background-color: white;
  overflow-y: auto; //scroll
  overflow-x: hidden;

  /* Shell do admin (redesign V3): menu lateral de 240px e barra de 60px fixos. */
  body[data-admin-shell] & {
    padding-left: 240px;
    padding-top: 60px;
    background-color: var(--bg);
    box-sizing: border-box;
    min-height: 100vh;
  }
  body[data-admin-shell] & > * {
    width: 100% !important;
    max-width: 100%;
  }
`;
